export const SandboxOptions = Object.freeze({
  ALLOW_FORMS: 'allow-forms',
  ALLOW_MODALS: 'allow-modals',
  ALLOW_ORIENTATION_LOCK: 'allow-orientation-lock',
  ALLOW_POINTER_LOCK: 'allow-pointer-lock',
  ALLOW_POPUPS: 'allow-popups',
  ALLOW_POPUPS_TO_ESCAPER_SANDBOX: 'allow-popups-to-escape-sandbox',
  ALLOW_PRESENTATION: 'allow-presentation',
  ALLOW_SAME_ORIGIN: 'allow-same-origin',
  ALLOW_SCRIPTS: 'allow-scripts',
  ALLOW_TOP_NAVIGATION: 'allow-top-navigation',
  ALLOW_TOP_NAVIGATION_BY_USER_ACTIVATION: 'allow-top-navigation-by-user-activation'
})

export const LayoutOptions = Object.freeze({
  FIXED_WIDTH: 'Fixed Width',
  EXPANDABLE: 'Expandable'
})
